// extracted by mini-css-extract-plugin
module.exports = {"restaurant-menu-sidebar-filters":"styles_restaurant-menu-sidebar-filters__rVQ5G"};